import { memo, ReactNode } from "react";
import { FloatingUIPortal } from "../ui/FloatingUIPortal";
import { ModalProvider } from "./modals/ModalContext";
import { NotificationProvider } from "./notifications";
import { ThemeModeProvider, ThemeModeProviderProps } from "./ThemeMode";

export type MimicContextProviderProps = {
  children: ReactNode | ReactNode [],
  themeModeProviderProps?: ThemeModeProviderProps
}

export const MimicContextProvider = memo<MimicContextProviderProps>(({ children, themeModeProviderProps }) => {
  return (
    <ThemeModeProvider {...themeModeProviderProps}>
      <FloatingUIPortal>
        <NotificationProvider>
          <ModalProvider>
            {children}
          </ModalProvider>
        </NotificationProvider>
      </FloatingUIPortal>
    </ThemeModeProvider>
  );
});